<template>
  <!--   -->
  <div class="chinese-report__group">
    <ol v-if="chineseReportFindings.length">
      <li
        v-for="findingInfo in chineseReportFindings"
        :key="findingInfo.key"
        class="mb-2"
      >
        <h3 class="mb-1">{{ findingInfo.cName }}</h3>

        <ul v-if="findingInfo.records?.length > 0">
          <li
            v-for="(record, recordsIndex) in findingInfo.records"
            :key="recordsIndex"
            class="mb-1"
          >
            <div v-for="(value, field) in record" :key="field">
              <p v-if="value !== null">
                <label
                  style="margin: 3px"
                  v-if="
                    findingInfo.records?.length > 1 &&
                    findingInfo.takeNote == 500
                  "
                >
                  病灶 {{ recordsIndex + 1 }}</label
                >

                <label style="margin-right: 3px">{{ field }}:</label>
                <label> {{ value }}</label>
              </p>
            </div>
          </li>
        </ul>
      </li>
    </ol>
    <div v-else class="ml-3">
      <h3>無</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChineseReportFindingItems',
  props: {
    chineseReportFindings: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped>
ul,
li {
  margin: 0;
  padding: 0;
}
ul > li {
  list-style: none;
}
</style>
